module.exports = __webpack_public_path__ + "static/media/check.a11a2803.png";